import type { Book } from "#/types";

import { getCoverUrl } from "#/client";
import { privacySignal } from "#/feature/tts-playback/tts-store";
import { useSignal } from "#/use-signal";
import { useNavigate } from "react-router-dom";
import { cx } from "styled-system/css";
import { useState } from "react";

import {
  cardContainerStyles,
  imageWrapperStyles,
  imageContainerStyles,
  imageStyles,
  infoContainerStyles,
  titleStyles,
  titleHoverStyles,
} from "./book-card.css";
import { isFull as checkIsFull } from "./use-library";
import { Card } from "#/components/card/card";

interface BookCardProps {
  book: Book;
}

export function BookCard({ book }: BookCardProps) {
  const navigate = useNavigate();
  const privacyMode = useSignal(privacySignal);
  const [isHovered, setIsHovered] = useState(false);
  const isFull = checkIsFull(book);

  return (
    <Card
      onClick={() => navigate(`/book/${book.id}`)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={cardContainerStyles}
    >
      <div
        className={imageWrapperStyles}
        style={isHovered ? { transform: "translateY(-4px)" } : undefined}
      >
        <div className={imageContainerStyles}>
          {!privacyMode ? (
            <img
              src={getCoverUrl(book.id)}
              alt={book.title}
              className={imageStyles}
              onError={(event) => {
                event.currentTarget.src =
                  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%239ca3af'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253' /%3E%3C/svg%3E";
              }}
            />
          ) : (
            <div
              className={imageStyles}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "var(--colors-bg-base300)",
              }}
            >
              <div style={{ color: "var(--colors-text-base)", opacity: 0.2 }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  width="48"
                  height="48"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                    d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                  />
                </svg>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className={infoContainerStyles}>
        <h3 className={cx(titleStyles, isHovered && titleHoverStyles)}>{book.title}</h3>
      </div>
    </Card>
  );
}
